import * as c from '../constants/StudentSSDAccommodationsConstants'

const initialState = {
  accommodations: {},
  fetching: false,
  fetched: false,
  error: null
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case c.FETCH_STUDENT_SSD_ACCOMMODATIONS_PENDING:
      return { ...state, fetching: true, fetched: false, error: null }

    case c.FETCH_STUDENT_SSD_ACCOMMODATIONS_FULFILLED:
      return {
        ...state,
        fetching: false,
        fetched: true,
        accommodations: {
          ...state.accommodations,
          [payload.studentId]: payload.data.accommodations
        }
      }

    case c.FETCH_STUDENT_SSD_ACCOMMODATIONS_REJECTED:
      return { ...state, fetching: false, fetched: false, error: payload }

    default:
      return state
  }
}
